import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const UPDATE_ROUND_CASES = "UPDATE_ROUND_CASES";

export const service = async (data) => {
  const options: object = {
    url: `/api/ExternalAudit/UpdateRoundCases`,
    method: "POST",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(UPDATE_ROUND_CASES, service, mock);
